import React from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownOffAltOutlinedIcon from '@mui/icons-material/ThumbDownOffAltOutlined';
import {
	StyledFlagHelpful,
	StyledFlagHelpfulContainer,
	StyledFlagIconList,
	StyledMessage,
} from './kbFlagHelpful.style';
import Typography from "component/MarketPlace/Typography/Typography";
import { handleKeyPress } from "utils/functions";


export interface IKBFlagHelpful {
	rating: number,
	useful: string,
	showMessage: boolean,
	isUseful: boolean,
	isBoxContent?: boolean;
	handleChangeUseful: (val: string) => void,
	locale: {
		heading: string,
		labelQuestion: string,
		labelYes: string,
		labelNo: string,
		thankYouForFeedback: string,
	},
}

const KBFlagHelpful = (props: IKBFlagHelpful) => {
	const { useful, showMessage, locale, isBoxContent } = props;

	const handleChangeUseful = (val: string) => {
		props.handleChangeUseful(val);
	};

	return (
		<StyledFlagHelpful>
			<StyledFlagHelpfulContainer container display='flex' flexDirection={{ sm: "column", md: "row"}}>
				<Grid display='flex' alignItems='center' paddingLeft={{xs: "10px", sm: "10px", md: "20px"}} item xs={12} md={isBoxContent ? 12 : 8}>
					<Typography variant="body2" tabIndex={0}>{locale?.labelQuestion}</Typography>
					<StyledFlagIconList className={`flag-icon-list`}>
						<Button
							tabIndex={0}
							onClick={() => handleChangeUseful("yes")}
							onKeyDown={(e) => handleKeyPress(e, 'Enter', () => handleChangeUseful("yes"))}
							className={`flag-icon flag-like-icon icon-${useful === "yes" ? useful : ''} ${useful === "yes" ? 'icon-disabled' : ''}`}
							disabled={useful === "yes" ? true : false}
              id="btn-kbdetailuseful-yes"
						>
							<span>{locale?.labelYes}</span>
							<ThumbUpAltIcon fontSize="small"/>

						</Button>
						<Button
							tabIndex={0}
							onClick={() => handleChangeUseful("no")}
							onKeyDown={(e) => handleKeyPress(e, 'Enter', () => handleChangeUseful("yes"))}
							className={`flag-icon flag-dislike-icon icon-${useful === "no" ? useful : ''} ${useful === "no" ? 'icon-disabled' : ''}`}
							disabled={useful === "no" ? true : false}
              id="btn-kbdetailuseful-no"
						>
							<span>{locale?.labelNo}</span>
							<ThumbDownOffAltOutlinedIcon  fontSize="small"/>

						</Button>
					</StyledFlagIconList>
				</Grid>
				<StyledMessage item xs={12} md={isBoxContent ? 12 : 4}>
					{/* show notification when change feedback */}
					{showMessage && <div id='hideMe' tabIndex={0}>{locale?.thankYouForFeedback}</div>}
				</StyledMessage>
			</StyledFlagHelpfulContainer>
		</StyledFlagHelpful>
	);
};

KBFlagHelpful.defaultProps = {
	useful: "",
	showMessage: false,
	isBoxContent: false,
	handleChangeUseful: () => { },
	locale: {
		id: "f234a0dc-a0ea-11ec-b909-0242ac120002",
		heading: "Help us, help you.",
		labelQuestion: "Was this article useful?",
		labelYes: "Yes",
		labelNo: "No",
		thankYouForFeedback: "Thank you for your feedback."
	}
};

export default KBFlagHelpful;
